var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"layout"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"page-title"},[_vm._v("數據字典")])])],1),_c('div',{staticClass:"item",on:{"click":_vm.onClicked}},[_vm._v("課題範圍")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }